import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGallary, IGallaryInitialState } from "./gallaryModal";
import {
  ActiveInactiveGallary,
  // GallaryImageUpload,
  createGallary,
  deleteGallary,
  getAllActiveGallarys,
  getAllGallarys,
  getGallaryByID,
  updateGallary,
} from "./services/gallary.services";

const initialState: IGallaryInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  GallaryID: null,
  GallaryList: [],
  GallaryDetail: {
    ImgAlt: "",
    GalleryImage: "",
    IsActive: 1,
  },
};

const gallarySlice = createSlice({
  name: "gallary",
  initialState,
  reducers: {
    clearGallaryDetails: (state) => {
      state.GallaryDetail = initialState.GallaryDetail;
    },
    setGallaryID: (state, action) => {
      state.GallaryID = action.payload;
    },
    clearGallaryID: (state) => {
      state.GallaryID = initialState.GallaryID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllGallarys.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllGallarys.fulfilled,
      (state, action: PayloadAction<IGallary[]>) => {
        state.loading = false;
        state.GallaryList = action.payload || [];
      }
    );
    builder.addCase(getAllGallarys.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.GallaryList = [];
    });
    builder.addCase(createGallary.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createGallary.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createGallary.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateGallary.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(updateGallary.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateGallary.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteGallary.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteGallary.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteGallary.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getGallaryByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getGallaryByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.GallaryDetail = action.payload;
    });
    builder.addCase(getGallaryByID.rejected, (state, action) => {
      state.formLoading = false;
      state.GallaryDetail = initialState.GallaryDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveGallarys.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveGallarys.fulfilled,
      (state, action: PayloadAction<IGallary[]>) => {
        state.loading = false;
        state.GallaryList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveGallarys.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.GallaryList = [];
    });
    builder.addCase(ActiveInactiveGallary.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveGallary.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveGallary.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    // builder.addCase(GallaryImageUpload.pending, (state) => {
    //   state.loading = true;
    //   state.error = "";
    // });
    // builder.addCase(GallaryImageUpload.fulfilled, (state) => {
    //   state.loading = false;
    // });
    // builder.addCase(GallaryImageUpload.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.error.message || "Something went wrong";
    // });
  },
});

export const { clearGallaryDetails, clearGallaryID, setGallaryID } =
  gallarySlice.actions;
export default gallarySlice.reducer;
